<div class="sign-in">
  <div class="left">

    <div class="container">
      <img src="assets/images/Isolation_Mode.svg" alt="App Icon"
        style="align-items: start; width: 98%; margin-bottom: 30px;">
      <h1 class="title">{{ title }}</h1>
      <p class="sub-title">{{ subTitle }}</p>
      <form [formGroup]="authForm" (ngSubmit)="login()" style="padding-left: 20px;">
        <div class="error-container" *ngIf="errorMsg?.trim()">
          {{ errorMsg}}
        </div>

        <div class="form-group">
          <rap-spinner class="loader-view" *ngIf="isLoading" [showSpinner]="false"></rap-spinner>
          <label for="email">Email address</label>
          <div class="input-container">
            <input type="email" class="search-input" [class.submitted]="submitted"
              [ngClass]="{'is-invalid': submitted && hasEmailError()}" formControlName="email"
              placeholder="Enter an email address" />
            <div class="auth-icons">
              <i class="bi bi-x-circle-fill" [class.icon-hidden]="!(submitted && hasEmailError())"
                style="margin-left: 10px;" (click)="clearInput('email')"></i>
              <i class="bi bi-envelope-fill" style="margin-left: 10px;"></i>
              <i class="bi bi-check-circle-fill" [class.icon-hidden]="!(submitted && !hasEmailError())"
                style="margin-left: 10px; color: green;"></i>
            </div>

          </div>
          <div *ngIf="submitted && f['email'].errors" class="rap-error-text">
            <span *ngIf="f['email'].errors?.['required']">Email is required</span>
            <span *ngIf="authForm.controls.email.errors.email">Please enter a valid email address</span>
          </div>
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <app-password-input [submitted]="submitted" [formControl]="f['password']"></app-password-input>
        </div>

        <a class="help-text" (click)="navigateToPasswordHelp()">
          Need help signing in?
        </a>

        <rap-rect-button-loader [isLoading]="isLoading" [disabled]="false" buttonClass="btn btn-dark btn-signin"
          type="submit" (clickEvent)="login()">
          Sign In
        </rap-rect-button-loader>

        <rap-link-divider></rap-link-divider>

        <rap-rect-button-loader [isLoading]="false" [disabled]="false" buttonClass="btn btn-light btn-create"
          type="submit" (clickEvent)="navigateToCreateAccount()">
          Create an account
        </rap-rect-button-loader>

        <!-- <button type="button" class="btn-create" (click)="navigateToCreateVILSAccount()">
          Login as VILS?
        </button> -->

      </form>
      <rap-terms-privacy></rap-terms-privacy>

    </div>
  </div>
  <div class="right">
    <div class="container" *ngIf="isPackageExpired">
      <p style="color: white;">{{subMessage}}
      </p>
      <rap-rect-button-loader [isLoading]="false" [disabled]="false" buttonClass="btn btn-light btn-create"
        type="submit" (clickEvent)="CognitoGroupNotAssigned ? openStripePortal() : startNewSubscription()">
        {{ CognitoGroupNotAssigned ? 'Update' : 'Subscribe' }}
      </rap-rect-button-loader>

    </div>
  </div>
</div>